
import { defineComponent, reactive, computed } from 'vue'
import { faBlog, faHome, faAddressCard, faWrench, faBriefcase, faAngleDown } from '@fortawesome/free-solid-svg-icons'
import { faVuejs, faQuora } from '@fortawesome/free-brands-svg-icons'
import router from '@/router'

export default defineComponent({
  props: {
    isThemeChanged: Boolean,
    isCollapsed: Boolean,
    currentPage: String
  },
  setup () {
    const accordions = reactive([
      {
        labelName: 'OPEN EDITORS',
        isOpen: true,
        paths: [
          {
            icon: faVuejs,
            color: '#41b883',
            name: 'MySite',
            link: 'https://github.com/taku-hu/portfolio-site'
          }
        ]
      },
      {
        labelName: 'posts',
        isOpen: true,
        paths: [
          {
            icon: faBlog,
            color: '#287dc0',
            name: 'blog',
            link: 'https://taku-hu-blog.netlify.app/'
          },
          {
            icon: faQuora,
            color: '#55c500',
            name: 'Qiita',
            link: 'https://qiita.com/taku-hu'
          }
        ]
      },
      {
        labelName: 'pages',
        isOpen: true,
        paths: [
          {
            icon: faHome,
            color: '#F0675F',
            name: 'Home',
            link: '/'
          },
          {
            icon: faAddressCard,
            color: '#108FB7',
            name: 'About',
            link: '/about'
          },
          {
            icon: faWrench,
            color: '#FFED39',
            name: 'Skills',
            link: '/skills'
          },
          {
            icon: faBriefcase,
            color: '#29A7A3',
            name: 'Works',
            link: '/works'
          }
        ]
      }
    ])
    type AccordionItem = typeof accordions[number]
    type AccordionItemPath = AccordionItem['paths'][number]

    const icons = computed(() => ({ faAngleDown }))

    const toggleAccordion = ({ labelName }: AccordionItem) => {
      const selected = accordions.find(accordion => accordion.labelName === labelName)
      if (selected) {
        selected.isOpen = !selected.isOpen
      }
    }

    const transitionPage = ({ labelName }: AccordionItem, { link }: AccordionItemPath) => {
      if (labelName === 'pages') {
        router.push({ path: link })
      } else {
        open(link, '_blank')
      }
    }

    return {
      accordions,
      icons,
      toggleAccordion,
      transitionPage
    }
  }
})
